import styled from 'styled-components';
import { step } from 'tokens';

export const Error = styled.p`
	color: red;
	margin-top: 1em;
	font-family: 'Inter', sans-serif;
	font-size: 12px;
	height: ${step}px;
`;

export const MessageContainer = styled.div`
	--input-width: 100%;
`;

export const Buttons = styled.div<{ $isMobile?: boolean }>`
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	padding-top: 2px;

	/* Mobile-specific button layout */
	${({ $isMobile }) =>
		$isMobile &&
		`
		flex-direction: column;
		gap: 12px;
		padding-top: 8px;

		/* Make buttons full-width on mobile for better touch targets */
		button {
			width: 100%;
			min-height: 44px;
			font-size: 16px;
		}
	`}
`;

export const Label = styled.div`
	color: ${({ theme }) => theme.gray['1000']};
	font-size: 12px;
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-top: 12px;
`;

export const MultilineInput = styled.div`
	max-height: 250px;
	overflow-y: scroll;
	& :focus {
		border: 1px solid ${({ theme }) => theme.gray['700']};
	}
	width: 100%;
`;

export const RowPlaceholder = styled.div`
	width: 500px;
`;

export const TextInput = styled.div`
	color: ${({ theme }) => theme.gray['1000']};

	background: ${({ theme }) => theme.gray['100']};
	border: 1px solid transparent;
	padding-left: 6px;

	& :focus {
		border: 1px solid ${({ theme }) => theme.gray['700']};
	}
	width: 100%;
`;

export const Spacer = styled.div`
	height: 8px;
`;
export const ThumbnailContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 12px;
	padding-bottom: 12px;
`;

export const SectionTitle = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray['1000']};
	margin-bottom: 12px;
	font-weight: 600;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 8px;
	right: 8px;
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 4px;

	&:hover {
		background-color: ${({ theme }) => theme.gray['100']};
	}

	// disabling accessibility highlight
	// i had a very annoying but where pressing Esc to dismiss a modal made the highlight
	// appear NEXT time it opened. couldn't disentangle it within my timebox. this hack will have to do.
	&:focus {
		outline: none;
	}

	/* Larger touch target on mobile */
	[data-mobile='true'] & {
		width: 44px;
		height: 44px;
		padding: 10px;
		top: 12px;
		right: 12px;
	}
`;

export const BackButton = styled.button`
	background: none;
	display: flex;
	align-items: center;
	justify-content: center;
	&:hover {
		background-color: ${({ theme }) => theme.gray['100']};
	}
	border: 0;
	padding-top: 6px;
	padding-bottom: 6px;
	margin-top: 1px;

	/* Larger touch target on mobile */
	[data-mobile='true'] & {
		padding: 10px;
		min-width: 44px;
		min-height: 44px;
	}
`;

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;
